import {
  editable,
  iframeLink,
  moduleHeight,
  moduleHeightUnit,
  moduleWidthSelect,
} from '@/src/tools/contentModulesFieldName';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import {
  EModuleHeightUnit,
  EModuleWidth,
  EnumModuleType,
} from '@/src/types/common/module';
import i18n from '../i18n';
import { ResponsiveContainer, ResponsiveField } from '../util';
import { IFRAME, MOUDLE_STYLE, moduleStyleFields } from './constant';

export default (values: any, responsiveType: EPreviewSize) => {
  const iframeSetting = getSettingTemplate(values, responsiveType);
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsiveIframe,
  );
  return [
    {
      title: i18n['general.content.iframe'],
      id: IFRAME,
      field: iframeSetting,
      fields: [
        [iframeLink],
        [moduleWidthSelect],
        [moduleHeight],
        [moduleHeightUnit],
      ],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
  ];
};

export const not_editable = [iframeLink, ...moduleStyle_not_editable];

import {
  getModuleStyleTemplate,
  moduleStyle_not_editable,
} from './imageCarousel';

export const getSettingTemplate = (
  values: any,
  responsiveType: EPreviewSize,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${IFRAME}_${editable}`];
  return [
    {
      field: ResponsiveField.IframeLink,
      disabled: responsiveType !== EPreviewSize.WIDE,
      title: i18n['general.content.iframelink'],
    },
    {
      field: ResponsiveField.ModuleWidth,
      disabled: !v,
      options: [
        { label: i18n['general.content.fullWidth'], value: EModuleWidth.FULL },
        { label: i18n['general.content.wideWidth'], value: EModuleWidth.WIDE },
        { label: i18n['general.content.none'], value: EModuleWidth.NONE },
      ],
    },
    {
      field: ResponsiveField.ModuleHeight,
      title: i18n['general.content.moduleHeight'],
      disabled: !v,
      options: [
        { label: '%', value: EModuleHeightUnit.Percentage },
        { label: 'px', value: EModuleHeightUnit.Pixel },
      ],
    },
  ];
};
